import { render, staticRenderFns } from "./gameStyle.vue?vue&type=template&id=5882b31c&"
import script from "./gameStyle.vue?vue&type=script&lang=js&"
export * from "./gameStyle.vue?vue&type=script&lang=js&"
import style0 from "./gameStyle.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5882b31c')) {
      api.createRecord('5882b31c', component.options)
    } else {
      api.reload('5882b31c', component.options)
    }
    module.hot.accept("./gameStyle.vue?vue&type=template&id=5882b31c&", function () {
      api.rerender('5882b31c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/datalist/gameStyle.vue"
export default component.exports